export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "home": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accueil"])},
        "pilotage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pilotage"])},
        "plan_sales": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contrats"])},
        "merchants": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Marchands"])},
        "organizations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Organisations"])},
        "stores": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Points de vente"])},
        "users": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utilisateurs"])},
        "internal": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Interne"])},
        "internal_users": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utilisateurs"])}
      },
      "en": {
        "home": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Home"])},
        "pilotage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Performance"])},
        "plan_sales": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contracts"])},
        "merchants": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Merchants"])},
        "organizations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Organizations"])},
        "stores": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Points of sale"])},
        "users": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Users"])},
        "internal": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Internal"])},
        "internal_users": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Users"])}
      }
    }
  })
}
